import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ChatNotificationSoundService {
  private context?: AudioContext;
  private lastPlayed = 0;
  enabled = this.readPreference();
  private readPreference(): boolean { try { return localStorage.getItem('repair-chat-sound') !== 'off'; } catch { return true; } }
  private unlock = (): void => {
    if (!this.enabled) return;
    try {
      this.context ??= new AudioContext();
      if (this.context.state === 'suspended') void this.context.resume().catch(() => {});
    } catch { /* The visual notice remains available without audio support. */ }
  };
  listen(): void { document.addEventListener('pointerdown', this.unlock); document.addEventListener('keydown', this.unlock); }
  stop(): void {
    document.removeEventListener('pointerdown', this.unlock); document.removeEventListener('keydown', this.unlock);
    if (this.context) void this.context.close().catch(() => {});
    this.context = undefined;
  }
  toggle(): void {
    this.enabled = !this.enabled;
    try { localStorage.setItem('repair-chat-sound', this.enabled ? 'on' : 'off'); } catch { }
    if (this.enabled) this.unlock();
  }
  play(): void {
    const context = this.context;
    if (!this.enabled || !context || context.state !== 'running' || Date.now() - this.lastPlayed < 1500) return;
    this.lastPlayed = Date.now();
    // Two soft notes, with a short fade to avoid clicks. No external audio download.
    for (const [offset, frequency] of [[0, 659.25], [0.12, 880]]) {
      const oscillator = context.createOscillator(), gain = context.createGain();
      const start = context.currentTime + offset;
      oscillator.frequency.value = frequency;
      gain.gain.setValueAtTime(0, start);
      gain.gain.linearRampToValueAtTime(0.055, start + 0.015);
      gain.gain.exponentialRampToValueAtTime(0.001, start + 0.22);
      oscillator.connect(gain); gain.connect(context.destination);
      oscillator.onended = () => { oscillator.disconnect(); gain.disconnect(); };
      oscillator.start(start); oscillator.stop(start + 0.24);
    }
  }
}
